<template>
  <footer id="contact-us" class="bg-primary-container text-white py-16 px-8 portal-home-font-2x">
    <div class="max-w-[1440px] mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        <div class="space-y-6">
          <div class="flex items-center gap-2">
            <span class="material-symbols-outlined text-secondary-container text-4xl">architecture</span>
            <div class="font-headline text-xl font-bold tracking-tight">
              四川省企联企业管理<br>创新工作平台
            </div>
          </div>
          <p class="text-surface-container-low/80 text-sm leading-relaxed">
            致力于打造四川省最具影响力的管理创新交流平台，通过数字化赋能与专家智库支持，助力企业实现高质量跨越式发展。
          </p>
          <div class="flex gap-4">
            <a class="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-secondary transition-colors" href="#" @click.prevent="goComingSoon">
              <span class="material-symbols-outlined text-sm">share</span>
            </a>
            <a class="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-secondary transition-colors" href="#" @click.prevent="goComingSoon">
              <span class="material-symbols-outlined text-sm">public</span>
            </a>
            <a class="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-secondary transition-colors" href="#" @click.prevent="goComingSoon">
              <span class="material-symbols-outlined text-sm">mail</span>
            </a>
          </div>
        </div>

        <div>
          <h4 class="font-headline text-lg font-bold mb-6 text-secondary-container">快速导航</h4>
          <ul class="space-y-4 text-sm text-surface-container-low/80">
            <li><a class="hover:text-secondary transition-colors" href="#" @click.prevent="goHomeSection('home')">首页</a></li>
            <li><a class="hover:text-secondary transition-colors" href="#" @click.prevent="goHomeSection('about')">关于我们</a></li>
            <li><a class="hover:text-secondary transition-colors" href="#" @click.prevent="goHomeSection('news')">新闻公告</a></li>
            <li><a class="hover:text-secondary transition-colors" href="#" @click.prevent="goHomeSection('case-center')">成果案例</a></li>
            <li><a class="hover:text-secondary transition-colors" href="#" @click.prevent="goHomeSection('experts')">专家库</a></li>
            <li><a class="hover:text-secondary transition-colors" href="#" @click.prevent="goAdminLogin">管理端登录</a></li>
          </ul>
        </div>

        <div>
          <h4 class="font-headline text-lg font-bold mb-6 text-secondary-container">联系我们</h4>
          <ul class="space-y-4 text-sm text-surface-container-low/80">
            <li class="flex gap-3">
              <span class="material-symbols-outlined text-secondary-container text-lg">location_on</span>
              <span>四川省成都市金牛区兴平路100号<br>住业大厦 9层</span>
            </li>
            <li class="flex gap-3">
              <span class="material-symbols-outlined text-secondary-container text-lg">call</span>
              <span>+86 (028) 8518 2812</span>
            </li>
            <li class="flex gap-3">
              <span class="material-symbols-outlined text-secondary-container text-lg">mail</span>
              <span>sceccx@163.com</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 class="font-headline text-lg font-bold mb-6 text-secondary-container">关注公众号</h4>
          <div class="bg-white p-2 w-32 h-32 rounded-lg mb-4 shadow-sm">
            <img :src="officialWechatQrCode" alt="微信公众号二维码" class="w-full h-full object-contain rounded-md" />
          </div>
          <p class="text-xs text-surface-container-low/60">扫描二维码，获取最新行业资讯与平台动态</p>
        </div>
      </div>

      <div class="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-surface-container-low/40">
        <p>© 2026 四川省企联企业管理创新工作平台. All Rights Reserved. 蜀ICP备2025125984号-3</p>
        <div class="flex gap-6">
          <a class="hover:text-white transition-colors" href="#" @click.prevent="goComingSoon">法律声明</a>
          <a class="hover:text-white transition-colors" href="#" @click.prevent="goComingSoon">隐私政策</a>
          <a class="hover:text-white transition-colors" href="#" @click.prevent="goComingSoon">站点地图</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import officialWechatQrCode from '@/assets/img/official-wechat-qrcode.png'
import { buildPortalApplyUrl } from '@/utils/portal'

export default {
  name: 'PortalFooter',
  data () {
    return {
      officialWechatQrCode
    }
  },
  methods: {
    goHomeSection (section) {
      if (this.$route.path !== '/home' && this.$route.path !== '/') {
        if (section === 'case-center') {
          this.$router.push('/case-center')
          return
        }
        this.$router.push({ path: '/home', query: { section } })
        return
      }
      this.$emit('scroll-to', section)
    },
    goAdminLogin () {
      window.location.href = buildPortalApplyUrl('/login', {
        source: 'homepage',
        returnUrl: `${window.location.origin}/#/home`
      })
    },
    goComingSoon () {
      this.$router.push('/coming-soon')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PortalFooter.vue